export abstract class BusEvent {}
